// A segment's display name: its own label if it has one, else "Trail #N".
// Labels name the pieces of catch-all groups like "Unnamed Trails".
export function segmentName(s, sep = ' #') {
  if (!s) return '';
  if (s.segment_label) return s.segment_label;
  return s.segment_number ? `${s.trail_name}${sep}${s.segment_number}` : s.trail_name;
}
